import { createFileRoute, notFound } from "@tanstack/react-router";
import homeStyles from "../styles/platform-home.css?url";
import rewardsStyles from "../styles/platform-monthly-rewards.css?url";
import type { StructuredData } from "../../src/lib/structured-data";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { MonthlyRewardsPage } from "../platform/monthly-rewards-page";
import { loadMonthlyRewardsPage } from "../platform/product-pages";

/**
 * Drate's page for creators who mail members something each month (/monthly-rewards), where the
 * "Monthly rewards, made simple." Instagram ad lands; a 404 on creator sites.
 */
export const Route = createFileRoute("/monthly-rewards")({
  loader: async () => {
    const page = await loadMonthlyRewardsPage();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          withStylesheet(
            platformPageHead(platformShellFrom(matches), {
              pathname: "/monthly-rewards",
              title: "Monthly rewards made simple | Drate",
              description:
                "Mail your members stickers, prints or a box each month. Drate builds the shipping list for you, so there are no spreadsheets to sort.",
              canonicalPath: "/monthly-rewards",
              structuredData: JSON.parse(loaderData.structuredData) as StructuredData,
            }),
            homeStyles,
          ),
          rewardsStyles,
        )
      : {},
  component: MonthlyRewardsPage,
});
